import { Alert, AlertIcon, Box, Link, Text } from "@chakra-ui/react";
import { Note } from "common";
import { useMemo } from "react";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { Link as ReactRouterLink } from "react-router-dom";
import { NoteBody } from "./NoteBody";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteTeam } from "./useNoteTeam";
import { useNoteAccountName } from "./useNoteAccountName";
import { useNoteTeamName } from "./useNoteTeamName";
import { useNoteTeamPoint } from "./useNoteTeamPoint";

interface NoteTeamPointBodyProps {
  note: Note;
}

export const NoteTeamPointBody = ({ note }: NoteTeamPointBodyProps) => {
  const account = useNoteAccount(note);
  const team = useNoteTeam(note);
  const teamPoint = useNoteTeamPoint(note);
  const accountName = useNoteAccountName(note);
  const teamName = useNoteTeamName(note);
  const messageBody = useMemo(
    () =>
      teamPoint
        ? ` ${teamPoint.value > 0 ? "awarded" : "took away"} ${Math.abs(
            teamPoint.value
          )} points ${teamPoint.value > 0 ? "to" : "from"} `
        : `awarded points to `,
    [teamPoint]
  );

  return (
    <Box
      width={"100%"}
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
    >
      <NoteBody note={note}>
        <Text
          width={"100%"}
          textAlign={"center"}
          marginLeft={2}
          marginRight={2}
        >
          <Link
            color={THEME_COLOR_SCHEME}
            as={ReactRouterLink}
            to={`/account/${account?.id}`}
          >
            {accountName}
          </Link>
          {messageBody}
          <Link
            color={THEME_COLOR_SCHEME}
            as={ReactRouterLink}
            to={`/team/${team?.id}`}
          >
            {teamName}
          </Link>
        </Text>
      </NoteBody>
      <Alert status="info" marginTop={2} variant={"left-accent"}>
        <AlertIcon />
        {teamPoint?.note}
      </Alert>
    </Box>
  );
};
